// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file merchant/v1/cart.proto (package merchant.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Address, Money, ShippingMethod } from "../../common/v1/common_pb";
import { Discount, TaxRate, TransactionCharge } from "./pricing_pb";
import { Product } from "./product_pb";

/**
 * Next Id: 7
 *
 * @generated from message merchant.v1.Cart
 */
export const Cart = proto3.makeMessageType(
  "merchant.v1.Cart",
  () => [
    { no: 1, name: "total_transaction_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "subtotal_amount", kind: "message", T: Money },
    { no: 2, name: "total_tax", kind: "message", T: Money },
    { no: 5, name: "line_items", kind: "message", T: LineItem, repeated: true },
    { no: 6, name: "shipping_address", kind: "message", T: Address },
    { no: 9, name: "shipping_methods", kind: "message", T: ShippingMethod, repeated: true },
    { no: 10, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "transaction_charges", kind: "message", T: TransactionCharge, repeated: true },
    { no: 13, name: "discounts", kind: "message", T: Discount, repeated: true },
    { no: 14, name: "taxes", kind: "message", T: TaxRate, repeated: true },
    { no: 16, name: "total_fee_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 17, name: "transaction_discount_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 18, name: "tax_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 19, name: "total_shipping_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 20, name: "cart_metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 21, name: "ship_from_address_postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "transaction_advices", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 23, name: "tax_treatment_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message merchant.v1.LineItem
 */
export const LineItem = proto3.makeMessageType(
  "merchant.v1.LineItem",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "quantity", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "unit_price", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "image_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "product", kind: "message", T: Product },
    { no: 12, name: "transaction_charges", kind: "message", T: TransactionCharge, repeated: true },
    { no: 13, name: "discounts", kind: "message", T: Discount, repeated: true },
    { no: 14, name: "tax_rates", kind: "message", T: TaxRate, repeated: true },
    { no: 16, name: "total_fee_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 18, name: "total_tax_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 19, name: "total_shipping_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 20, name: "shipping_method", kind: "message", T: ShippingMethod },
    { no: 21, name: "line_item_metadata", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 22, name: "transaction_discount_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 23, name: "tax_inclusive_line_item_total_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 25, name: "line_item_unit_of_measure_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "sku", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 28, name: "upc", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 29, name: "taxable", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
  ],
);

/**
 * Pricing refers to how much the product or service costs.
 * By default (price only provided) price treated as a unit price.
 *
 * @generated from message merchant.v1.Price
 */
export const Price = proto3.makeMessageType(
  "merchant.v1.Price",
  () => [
    { no: 1, name: "unit_price", kind: "message", T: Money },
  ],
);

